import { useEffect } from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES, PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';

import { useGetConsorsNotesByLeadId } from './hooks/useGetConsorsNotesByLeadId';
import { useResetConsorsNotesFlagMutation } from './hooks/useResetConsorsNotesFlagMutation';
import { NoteListItem } from './NoteListItem';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import useLead from '~/features/leadDetails/hooks/useLead';
import { useMarkNotificationProcessed } from '~/features/notifications/hooks/useMarkNotificationProcessed';

export const NotesList = () => {
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { data } = useGetConsorsNotesByLeadId(leadId);
    const { data: lead } = useLead(leadId);
    const subscriptionIdentifier = lead?.consors?.subscriptionIdentifier;
    const { mutate: markProcessed } = useMarkNotificationProcessed();
    const { hasNewConsorsNotes, notes } = data ?? {};
    const canResetFlag = permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].resetConsorsNotesFlag;

    const { mutate: resetConsorsNotesFlag } = useResetConsorsNotesFlagMutation(leadId, {
        onSuccess: () => {
            // Only record after the backend acks the reset — otherwise we'd leak a "processed" entry
            // for an event that never happened.
            if (subscriptionIdentifier) {
                markProcessed({
                    kind: PROCESSED_NOTIFICATION_KINDS.BANK_REPORT,
                    loanRequestId: leadId,
                    subscriptionIdentifier,
                });
            }
        },
    });

    useEffect(() => {
        if (!hasNewConsorsNotes || !canResetFlag) return;
        resetConsorsNotesFlag();
    }, [hasNewConsorsNotes, canResetFlag, resetConsorsNotesFlag]);

    return (
        <div className="h-[250px] overflow-y-auto">
            {notes?.map((note) => (
                <NoteListItem key={note.data.id} note={note} />
            ))}
        </div>
    );
};
